import { IDictionary, ReadonlyRecord } from '@bimser/core';
import { List, Map, Record } from 'immutable';
import {
	DataSourceParameter,
	DataSourceParameterFactoryFromJS,
	IDataSourceParameter
} from './IDataSourceParameter';
import { DisplayExprML, DisplayExprMLFactoryFromJS, IDisplayExprML } from './IDisplayExprML';

export interface IBaseDataSource {
	connectionType?: any;
	fileId?: string;
	name: string;
	valueExpr?: string; // Specifies which data field provides unique values to the widget's value.
	runAtServer?: boolean; // Specifies fill data on server or client
	displayFormat?: string;
	field?: string;
	enableMultiLanguageDisplayExpr?: boolean;
	defaultValue?: any;
	useClientCachedData?: boolean;
}

export interface IDataSource extends IBaseDataSource {
	parameters?: IDataSourceParameter[];
	displayExpr?: string[]; // Specifies the data field whose values should be displayed.
	displayExprML?: IDictionary<IDisplayExprML>;
}

export interface IReadonlyBaseIDataSource extends IBaseDataSource {
	parameters?: List<DataSourceParameter>;
	displayExpr?: List<string>; // Specifies the data field whose values should be displayed.
	displayExprML?: Map<string, DisplayExprML>;
}

export type DataSource = ReadonlyRecord<IReadonlyBaseIDataSource>;

export const DataSourceFactory = Record<IReadonlyBaseIDataSource>({
	connectionType: null,
	fileId: null,
	name: null,
	displayExpr: List(),
	valueExpr: null,
	runAtServer: false,
	parameters: List(),
	displayFormat: null,
	field: null,
	enableMultiLanguageDisplayExpr: false,
	displayExprML: Map(),
	defaultValue: null,
	useClientCachedData: true
});

export const DataSourceFactoryFromJS = function (data: IDataSource) {
	const parameters = data.parameters?.map(i => DataSourceParameterFactoryFromJS(i)) || [];

	const displayExprs: IDictionary<DisplayExprML> = {};

	if (data.displayExprML) {
		for (const key in data.displayExprML) {
			displayExprs[key] = DisplayExprMLFactoryFromJS(data.displayExprML[key]);
		}
	}

	return DataSourceFactory({
		...data,
		parameters: List(parameters),
		displayExpr: List(data.displayExpr),
		displayExprML: Map(displayExprs)
	});
};

export { IDataSourceResponse } from './IDataSourceResponse';
